import { useEffect, useRef } from 'react';

// Хук хранит всегда актуальную ссылку на значение без вызова ре-рендера.
// Это может быть полезно, например, для хранения ссылок на DOM-элементы
// или других объектов, которые не должны вызывать повторный рендер при изменении
// и не находиться в зависимостях useEffect, useCallback и т.д.
export function useLatestValueRef<T>(value: T) {
  const ref = useRef(value);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref;
}
